<template>
  <div v-show="isActive" class="app-tab__panel" role="tabpanel" :aria-labelledby="tabId">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AppTab',
  inject: ['tabsProvider'],
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: ''
    },
    name: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tabId () {
      return `app-tab-${this._uid}`
    },
    isActive () {
      const { activeIndex, tabs } = this.tabsProvider
      const idx = this.name !== null
        ? tabs.findIndex(t => t.name === this.name)
        : tabs.indexOf(this)
      return idx === activeIndex
    }
  },
  created () {
    this.tabsProvider.register(this)
  },
  destroyed () {
    this.tabsProvider.unregister(this)
  }
}
</script>
